import React, { useState } from 'react';
import { Box, TextField, Button, Alert } from '@mui/material';

export default function TokenForm({ onSuccess }: { onSuccess: () => void }) {
  const [token, setToken] = useState('');
  const [error, setError] = useState('');

  async function save(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    const res = await fetch('/token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    });
    if (res.ok) { onSuccess(); } else { setError('Неверный токен'); }
  }

  return (
    <Box component="form" onSubmit={save}>
      <TextField
        label="API token"
        type="password"
        value={token}
        onChange={e => setToken(e.target.value)}
        fullWidth
        required
        size="small"
        sx={{ mb: 2 }}
      />
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Button type="submit" variant="contained">Сохранить</Button>
    </Box>
  );
}
